import React, { createContext, useState, useEffect, useContext } from 'react';

export const ChatbotContext = createContext();

export const ChatbotProvider = ({ children }) => {
  const [chatbotSettings, setChatbotSettings] = useState(() => {
    // Load saved settings from localStorage
    const saved = localStorage.getItem('chatbot-settings');
    const defaultSettings = {
      enabled: true, // Chatbot is enabled by default
    };
    
    if (saved) {
      try {
        return { ...defaultSettings, ...JSON.parse(saved) };
      } catch (e) {
        return defaultSettings;
      }
    }
    return defaultSettings;
  });

  // Save settings to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('chatbot-settings', JSON.stringify(chatbotSettings));
  }, [chatbotSettings]);

  const updateChatbotSetting = (key, value) => {
    setChatbotSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const resetChatbotSettings = () => {
    const defaultSettings = {
      enabled: true,
    };
    setChatbotSettings(defaultSettings);
    localStorage.removeItem('chatbot-settings');
  };

  const value = {
    chatbotSettings,
    updateChatbotSetting,
    resetChatbotSettings,
  };

  return (
    <ChatbotContext.Provider value={value}>
      {children}
    </ChatbotContext.Provider>
  );
};

export const useChatbot = () => {
  const context = useContext(ChatbotContext);
  if (!context) {
    throw new Error('useChatbot must be used within ChatbotProvider');
  }
  return context;
};